import styled, { css } from 'styled-components';
import Icon from '../Icon';
import Detail from '../Detail';

const pillVariants = {
  information: css`
    background: ${({ theme }) => theme.COLORS.INFO};
  `,
  warning: css`
    background: ${({ theme }) => theme.COLORS.PALE_ORANGE};
  `,
  error: css`
    background: ${({ theme }) => theme.COLORS.ERROR};
  `,
  filter: css`
    background: ${({ theme }) => theme.COLORS.BASE};
    border: 2px solid ${({ theme }) => theme.COLORS.NEUTRAL_50};
    box-sizing: border-box;
    max-width: 340px;
    margin: 3px;
    padding: 12px 4px 12px 12px;
  `
};

const pillIconFilterVariants = css`
  width: 9px;
  height: 9px;
  stroke: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  stroke-width: 2px;
  :hover {
    stroke: ${({ theme }) => theme.COLORS.TERTIARY};
  }
`;

const pillIconNonFilterVariants = css`
  width: 18px;
  height: 18px;
  margin-right: 10px;
`;

export const StyledPill = styled.div`
  display: flex;
  ${props => pillVariants[props.variant]};
  border-radius: 18px;
  justify-content: space-between;
  align-items: center;
  flex-direction: row nowrap;
  width: fit-content;
  height: 30px;
`;

export const StyledIcon = styled(Icon)`
  ${props =>
    props.variant === 'filter'
      ? pillIconFilterVariants
      : pillIconNonFilterVariants}
`;

export const StyledDetail = styled(Detail)`
  font-size: 12px;
  line-height: 12px;
`;

export const StyledCloseIconWrapper = styled.div`
  height: 30px;
  width: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: 3px;
  :hover ${StyledIcon} {
    stroke: ${({ theme }) => theme.COLORS.TERTIARY};
  }
`;

export default StyledPill;
